import { motion } from "framer-motion";
import { useLang } from "../../context/LanguageContext";
import { useContent } from "../../context/ContentContext";
import { mediaUrl } from "../../lib/api";

export default function Gallery() {
  const { t, pick } = useLang();
  const { content } = useContent();
  const gallery = content?.gallery || [];

  return (
    <section id="work" className="relative py-24 md:py-32 px-5 md:px-10 border-t border-white/10 tactical-grid-bg" data-testid="gallery-section">
      <div className="mx-auto max-w-[1400px]">
        <div className="mb-14">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-acid mb-4 flex items-center gap-3">
            <span className="w-8 h-px bg-acid" /> {t("work_kicker")}
          </p>
          <h2 className="font-display uppercase text-5xl md:text-7xl leading-[0.9] text-white">
            {t("work_title")}
          </h2>
        </div>

        {gallery.length === 0 ? (
          <div className="border border-dashed border-white/15 py-24 text-center text-silver font-mono uppercase tracking-widest text-sm">
            {t("work_empty")}
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {gallery.map((g, i) => (
              <motion.figure
                key={g.id || i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
                className={`group relative overflow-hidden border border-white/10 ${i % 5 === 0 ? "lg:row-span-2" : ""}`}
                data-testid={`gallery-item-${i}`}
              >
                <img
                  src={mediaUrl(g.url)}
                  alt={pick(g, "caption") || "Zurita's project"}
                  className={`w-full object-cover transition-transform duration-700 group-hover:scale-105 ${i % 5 === 0 ? "h-full min-h-[400px]" : "h-72"}`}
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-transparent to-transparent opacity-70" />
                {pick(g, "caption") && (
                  <figcaption className="absolute bottom-0 left-0 p-5 font-heading uppercase text-white text-lg tracking-wide">
                    {pick(g, "caption")}
                  </figcaption>
                )}
              </motion.figure>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
